"use strict";
var dragulaExpt = require('dragula');
exports.dragula = dragulaExpt.default || dragulaExpt;



//////////////////
// WEBPACK FOOTER
// /app/~/ng2-dragula/components/dragula.class.js
// module id = ../../../../ng2-dragula/components/dragula.class.js
// module chunks = 16